var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "diseases-statistics",
      class: { "diseases-statistics--compact": _vm.compact },
      attrs: { "data-qa": "diseases_statistics" },
    },
    [
      _c(
        "div",
        {
          staticClass: "diseases-statistics__columns d-flex ga-4",
          class: _vm.twoColumns
            ? "diseases-statistics__columns--two flex-wrap gc-6"
            : "flex-column",
          attrs: { "data-qa": "diseases_statistics_list" },
        },
        _vm._l(_setup.diseaseColumns, function (column, columnIndex) {
          return _c(
            "div",
            {
              key: columnIndex,
              staticClass:
                "diseases-statistics__column d-flex flex-column ga-4",
              class: {
                "diseases-statistics__column--two flex-grow-1": _vm.twoColumns,
              },
            },
            _vm._l(column, function (practice, i) {
              return _c(
                "div",
                {
                  key: `${columnIndex}-${i}`,
                  staticClass: "diseases-statistics__item d-flex align-start",
                  class: _vm.compact ? "ga-2" : "ga-4",
                  attrs: { "data-qa": "diseases_statistics_item" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "diseases-statistics__percent d-flex align-center justify-center flex-shrink-0 primary--text bg-primary rounded",
                      class: _vm.compact
                        ? "text-subtitle-2 px-2 py-1"
                        : "text-subtitle-1 px-3 py-1",
                      attrs: { "data-qa": "diseases_statistics_percent" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(practice.frequency) +
                          "%\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  practice.manipulation_type_translit
                    ? _c(
                        "div",
                        {
                          staticClass: "diseases-statistics__name flex-grow-1",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "text-decoration-none text--text",
                              class: _vm.compact
                                ? "text-body-2"
                                : "text-body-1",
                              attrs: {
                                href: `/${_setup.context.town.translit}/lechenie/${practice.manipulation_type_translit}/`,
                                "data-qa": "diseases_statistics_name",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_setup.getPracticeLabel(practice)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "diseases-statistics__name flex-grow-1",
                          class: _vm.compact ? "text-body-2" : "text-body-1",
                          attrs: { "data-qa": "diseases_statistics_name" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.getPracticeLabel(practice)) +
                              "\n        "
                          ),
                        ]
                      ),
                ]
              )
            }),
            0
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }